module.exports = __webpack_public_path__ + "img/rent5.7b5dc63b.jpg";